// extracted by mini-css-extract-plugin
export default {"leanCanvas":"LeanCanvas_leanCanvas__P3XhZ","loading":"LeanCanvas_loading__gG5Yu"};